export const STATUS_CONFIG = {
  open: { label: "Open", dotClass: "bg-blue-500", badgeClass: "bg-blue-50 text-blue-700 border-blue-200" },
  assigned: { label: "Assigned", dotClass: "bg-violet-500", badgeClass: "bg-violet-50 text-violet-700 border-violet-200" },
  in_progress: { label: "In Progress", dotClass: "bg-sky-600", badgeClass: "bg-sky-50 text-sky-700 border-sky-200" },
  on_hold: { label: "On Hold", dotClass: "bg-amber-500", badgeClass: "bg-amber-50 text-amber-700 border-amber-200" },
  resolved: { label: "Resolved", dotClass: "bg-emerald-500", badgeClass: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  closed: { label: "Closed", dotClass: "bg-zinc-400", badgeClass: "bg-zinc-100 text-zinc-600 border-zinc-300" },
  reopened: { label: "Reopened", dotClass: "bg-red-500", badgeClass: "bg-red-50 text-red-700 border-red-200" },
};

export const PRIORITY_CONFIG = {
  critical: { label: "Critical", badgeClass: "bg-red-50 text-red-700 border-red-200" },
  high: { label: "High", badgeClass: "bg-orange-50 text-orange-700 border-orange-200" },
  medium: { label: "Medium", badgeClass: "bg-amber-50 text-amber-700 border-amber-200" },
  low: { label: "Low", badgeClass: "bg-green-50 text-green-700 border-green-200" },
};

export const CATEGORY_OPTIONS = [
  { value: "reports", label: "Reports" },
  { value: "enhancements", label: "Enhancements" },
  { value: "customizations", label: "Customizations" },
  { value: "rfc", label: "RFC" },
  { value: "forms", label: "Forms" },
  { value: "conversions", label: "Conversions" },
  { value: "error_fix", label: "Error/Fix" },
  { value: "workflow", label: "Work Flow" },
  { value: "service_request", label: "Service Request" },
];

export const TYPE_OPTIONS = CATEGORY_OPTIONS; // Merged into category

export const MODULE_OPTIONS = [
  { value: "sap_sd", label: "SAP SD" },
  { value: "sap_mm", label: "SAP MM" },
  { value: "sap_fico", label: "SAP FICO" },
  { value: "sap_abap", label: "SAP ABAP" },
  { value: "sap_pi_po", label: "SAP PI/PO" },
  { value: "sap_pm", label: "SAP PM" },
  { value: "sap_ps", label: "SAP PS" },
  { value: "sap_hcm", label: "SAP HCM" },
];

export const PRIORITY_OPTIONS = [
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "assigned", label: "Assigned" },
  { value: "in_progress", label: "In Progress" },
  { value: "on_hold", label: "On Hold" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
  { value: "reopened", label: "Reopened" },
];

export const ROLE_LABELS = {
  admin: "Admin",
  manager: "Manager",
  agent: "Agent",
  end_user: "End User",
};

export function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.open;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium border rounded-sm ${config.badgeClass}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config.dotClass}`} />
      {config.label}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  const config = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-sm ${config.badgeClass}`}>
      {config.label}
    </span>
  );
}

const SLA_STATUS_CONFIG = {
  on_track: { label: "On Track", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  met: { label: "Met", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  at_risk: { label: "At Risk", className: "bg-amber-50 text-amber-700 border-amber-200" },
  breached: { label: "Breached", className: "bg-red-50 text-red-700 border-red-200" },
};

export function SLABadge({ type, status }) {
  const config = SLA_STATUS_CONFIG[status] || SLA_STATUS_CONFIG.on_track;
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border rounded-sm ${config.className}`}>
      {type === "response" ? "Resp" : "Resol"}: {config.label}
    </span>
  );
}
